import { helper } from './helper';

export const name = helper.accessor('name', {
  header: 'Name',
});
